import styled from "styled-components";

const NavWrapper = styled.nav`
  z-index: 999;
  &.header_section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    margin-top: 1px;
    height: 90px;
    transition: all 0.3s;
    background: transparent;

    &.sticky {
      position: fixed;
      top: 0;
      width: 100%;
      background: #131740;
      z-index: 1000;
      transition: all 0.2s;
      height: 70px;
      margin-top: 0;

      .menu_sect {
        height: 70px;
      }

    }
  }

  .menu_sect {
    height: 90px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .menu_left_sect {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .logo {
      a {
        display: inline-block;
      }
      span{
        font-family: "Poppins";
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 40px;
        color: #ffffff;
        margin-left: 10px;
      }
    }
  }

  .menu_right_sect {
    width: 78%;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  .menu_list {
    margin-left: 65px;
    margin-right: 65px;
    max-width: 650px;
    min-width: 409px;
    width: 100%;
    ul {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;
      padding: 0;

      li {
        position: relative;
        cursor: pointer;

        a,p {
          font-family: "Poppins";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          text-align: center;
          color: #ffffff;
          margin: 0;
        }

        &:hover {
          a,p {
            color: #FF06B7;
          }
        }

        /* submenu */
        &.submenu {
          .sub_menu_sect {
            background: transparent;
            border-top: 50px solid transparent;
            position: absolute;
            top: -50px;
            left: -20px;
            width: 190px;
            visibility: hidden;
            opacity: 0;
            z-index: -100;
            transition: all 0.5s;

            .sub_menu_list {
              padding: 15px 20px;
              background: #0D102D;
              flex-wrap: wrap;
              li {
                width: 100%;
                a,p {
                  font-family: "Poppins";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 40px;
                  color: rgba(255, 255, 255, 0.8);
                  text-transform: capitalize;
                  margin : 0;
                  text-align: left;
                }

                &:hover {
                  a,p {
                    color: #FF06B7;
                  }
                }
              }
            }
          }

          &:hover {
            .sub_menu_sect {
              top: 7px;
              visibility: visible;
              opacity: 1;
              z-index: 99;
            }
          }
        }
      }
    }
  }

  .menu_btns {
    display: flex;
    align-items: center;
    justify-content: end;
    align-items: center;
    min-width: 284px;
    button {
      color: #ffffff;
      text-transform: uppercase;
      font-family: "Poppins";
      font-weight: 400;
      font-size: 16px;
    }

    .menu_btn {
      display: none;
      border: none;
      background: transparent;
      cursor: pointer;
      svg {
        font-size: 40px;
      }
    }

    .register_btn {
      height: 60px;
      width: 180px;
      background-color: transparent;
      border: 1px solid #FF06B7;
      border-color: #FF06B7;
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
      border-radius: 10px 10px 10px 10px;
      text-transform: capitalize;
    }

  }

  @media (max-width: 1200px) {
      .menu_list{
        margin-right : 0;
      }
      .menu_btns{
          min-width: 250px;
      } 
  }

  @media (max-width: 1024px) {
    .menu_list {
      margin-right: 20px;
    }
  }
  @media (max-width: 992px) {

    .menu_left_sect{
      width: 100%;
    }

    .menu_right_sect {
      justify-content: end;
    }
    .menu_btns {
      justify-content: end;
      .menu_btn {
        display: block;
      }
    }

    .menu_btns {
      .register_btn {
        display: none;
      }
    }
    .menu_list {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
  }

  @media (max-width: 667px) {
    .menu_btns {
      .connect_btn {
        display: none;
      }

      .menu_btn {
        svg {
          font-size: 30px;
        }
      }
    }
  }

  @media (max-width: 540px) {
   .menu_left_sect{
      .logo {
        span{
          display: none;
        }
      }
   }

    .menu_right_sect {
      width: 50%;
      .menu_right_sect {
        width: 50%;
      }
    }
  }
`;

export default NavWrapper;
